import styled from 'styled-components';

export const Panel = styled.section`
  max-width: 1040px;
  margin: 40px auto 10px;
  padding: 36px 32px 28px;
  border-radius: 18px;
  background: radial-gradient(
      circle at 15% 0%,
      rgba(113, 151, 214, 0.28) 0,
      rgba(113, 151, 214, 0) 55%
    ),
    linear-gradient(160deg, #0f2137 0%, #1b3358 100%);
  box-shadow: 0 18px 40px rgba(15, 33, 55, 0.22);

  h3 {
    margin: 0 0 26px;
    color: #fff;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.01em;
    text-align: center;
  }

  @media (max-width: 767px) {
    margin-top: 28px;
    padding: 26px 16px 22px;

    h3 {
      font-size: 17px;
      margin-bottom: 18px;
    }
  }
`;

export const Tiles = styled.ul`
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;

  @media (max-width: 991px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  @media (max-width: 575px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
  }
`;

export const Tile = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 16px 8px 14px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.07);
  text-align: center;

  .icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    overflow: hidden;

    img {
      display: block;
      width: 100%;
      height: 100%;
    }

    /* Resource icons are transparent glyphs: they sit on a white square. */
    &.plain {
      background: #fff;
      padding: 4px;
    }
  }

  .name {
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.35;
  }

  @media (max-width: 575px) {
    padding: 12px 4px 10px;

    .icon {
      width: 38px;
      height: 38px;
    }

    .name {
      font-size: 12px;
    }
  }
`;
